import Grid from '@mui/material/Grid'
import React from 'react'
import { Container, Skeleton } from '@mui/material'
import Image12 from 'images/wholesale/012.svg'
import Image13 from 'images/wholesale/013.svg'
import Image14 from 'images/wholesale/014.svg'
import Image15 from 'images/wholesale/015.svg'
import { useCategoriesProductsCountQuery } from '@graphql/queries/__generated__/category.generated'
import { CategoryProductsCountFragment } from '@graphql/fragments/__generated__/CategoryProductsCount.generated'
import CountUp from 'react-countup'
import { useTranslation } from 'react-i18next'

const TITLE_COLOR = '#F0AE16'

interface Category {
  id: string
  image: string
  name: string
}

const getCount = (nodes: CategoryProductsCountFragment[], name: string): number => {
  const node = nodes.find(node_ => node_.name.toLowerCase().includes(name.toLowerCase()))
  return node?.specCount || 0
}

const CategoriesSection: React.FC = () => {
  const { t } = useTranslation()
  const { data, loading } = useCategoriesProductsCountQuery({
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })

  const categories: Category[] = [
    { id: '1', image: Image13, name: t('categoryCrossStitch', 'Cross-Stitch') },
    { id: '2', image: Image12, name: t('categoryDiamondPainting', 'Diamond Painting') },
    { id: '3', image: Image14, name: t('categoryBeading', 'Beading') },
    { id: '4', image: Image15, name: t('categoryEmbroidery', 'Embroidery') },
  ]
  return (
    <section className='py-20 pb-10 md:pb-20 text-center leading-tight'>
      <Container maxWidth='lg'>
        <Grid container spacing={0}>
          {categories.map(node => (
            <Grid item xs={6} md={3} key={node.id}>
              <div>
                <img className='h-80 md:h-130 mb-10 max-w-full' src={node.image} alt={node.name} draggable={false} />
              </div>
              <div className='text-2xl md:text-4xl'>{node.name}</div>
              <div className='mt-10 mb-20 md:mb-0' style={{ color: TITLE_COLOR }}>
                <div className='text-4xl md:text-6xl font-semibold'>
                  {loading && !data ? (
                    <Skeleton
                      height={20}
                      width={30}
                      variant='rectangular'
                      sx={{ display: 'inline-block', backgroundColor: TITLE_COLOR }}
                    />
                  ) : (
                    <CountUp
                      end={getCount(data?.categoriesProductsCount || [], node.name)}
                      duration={1}
                      redraw
                      enableScrollSpy
                    />
                  )}
                </div>
                <div className='text-lg'>{t('designs', 'designs')}</div>
              </div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  )
}

export default CategoriesSection
